export const PAGE_SIZE_OPTIONS = [25, 50, 100];
